export default "__VITE_ASSET__CNtN5gs6__"